import * as React from "react";
const SvgFiBrandsSketch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-sketch_svg__a)">
      <path
        fill="#151A2D"
        d="M23.901 8.567 18.995 1.96a.5.5 0 0 0-.349-.2l-6.59-.744a.5.5 0 0 0-.113 0l-6.59.744a.5.5 0 0 0-.348.2L.1 8.567a.505.505 0 0 0 .021.628l11.687 13.703q.013.016.028.028c.106.09.265.078.356-.028L23.879 9.195a.504.504 0 0 0 .022-.628m-1.369.243a.1.1 0 0 1-.099.08H20.05a.4.4 0 0 0-.325.205l-5.652 10.077-.009.014a.151.151 0 0 1-.26-.152l4.569-9.714.009-.02a.303.303 0 0 0-.283-.412H5.901l-.021.002a.304.304 0 0 0-.253.431l4.569 9.714.006.015a.152.152 0 0 1-.276.123L4.276 9.096l-.015-.024a.4.4 0 0 0-.338-.183h-2.37a.101.101 0 0 1-.007-.199l2.362-.509.027-.007a.4.4 0 0 0 .282-.299l.953-4.218.004-.013a.1.1 0 0 1 .117-.063.1.1 0 0 1 .079.103L5.196 7.35v.02a.203.203 0 0 0 .345.133l5.034-5.06.012-.01a.107.107 0 0 1 .147.153L7.019 7.207l-.014.02a.252.252 0 0 0 .21.391h9.59a.253.253 0 0 0 .176-.41l-3.716-4.625-.009-.013a.11.11 0 0 1 .025-.137.11.11 0 0 1 .143.008l5.034 5.06.015.014a.201.201 0 0 0 .329-.166l-.172-3.666V3.67a.101.101 0 0 1 .199-.013l.954 4.218.007.027c.042.14.157.248.302.28l2.362.508.013.004a.1.1 0 0 1 .065.116"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-sketch_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsSketch;
